import React from 'react';
import Image from 'components/AppImage';
import Icon from 'components/AppIcon';

const WelcomeSection = () => {
  const features = [
    {
      id: 1,
      icon: 'TreePine',
      title: 'Eco-Friendly Resort',
      description: 'Sustainable luxury in harmony with nature, featuring solar power and organic gardens'
    },
    {
      id: 2,
      icon: 'Waves',
      title: 'Adventure Activities',
      description: 'Thrilling white-water rafting, jungle safaris, and kayaking experiences'
    },
    {
      id: 3,
      icon: 'Award',
      title: 'Premium Service',
      description: 'Award-winning hospitality with personalized attention to every guest'
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl shadow-organic-xl">
              <Image
                src="https://images.pexels.com/photos/1134166/pexels-photo-1134166.jpeg"
                alt="Dandeli Adventure Resorts Welcome"
                className="w-full h-96 lg:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
            
            {/* Floating Stats Card */}
            <div className="absolute -bottom-6 -right-6 bg-card border border-border rounded-xl p-6 shadow-organic-lg">
              <div className="flex items-center space-x-4">
                <div className="text-center">
                  <p className="text-2xl font-heading font-bold text-primary">500+</p>
                  <p className="text-sm text-muted-foreground">Happy Guests</p>
                </div>
                <div className="w-px h-12 bg-border"></div>
                <div className="text-center">
                  <p className="text-2xl font-heading font-bold text-primary">4.8</p>
                  <p className="text-sm text-muted-foreground">Rating</p>
                </div>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
                Welcome to Dandeli's Premier Adventure Resort
              </h2>
              <p className="text-lg text-muted-foreground leading-relaxed">
                Nestled in the heart of Karnataka's Western Ghats, Dandeli Adventure Resorts offers an unparalleled blend of luxury and wilderness. Experience the thrill of adventure activities while enjoying world-class amenities in our eco-friendly accommodations.
              </p>
            </div>

            {/* Feature Cards */}
            <div className="space-y-6">
              {features?.map((feature) => (
                <div key={feature?.id} className="flex items-start space-x-4 p-4 rounded-lg hover:bg-muted/50 transition-organic">
                  <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                    <Icon name={feature?.icon} size={24} className="text-primary" />
                  </div>
                  <div>
                    <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
                      {feature?.title}
                    </h3>
                    <p className="text-muted-foreground">
                      {feature?.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA Section */}
            <div className="pt-4">
              <p className="text-sm text-muted-foreground mb-4">
                Since 2015 • Karnataka Tourism Approved • ISO 14001 Certified
              </p>
              <div className="flex items-center space-x-4">
                <div className="flex -space-x-2">
                  {[1, 2, 3, 4]?.map((i) => (
                    <div key={i} className="w-8 h-8 bg-primary/20 rounded-full border-2 border-background"></div>
                  ))}
                </div>
                <p className="text-sm text-muted-foreground">
                  Join 500+ satisfied guests who chose us for their adventure
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;